import {Component, OnInit} from '@angular/core';
import {TransferidFournisseurService} from '../transferid-fournisseur.service';
import {TranslateService} from '@ngx-translate/core';
import {AppTranslateService} from '../../../../modules/services/translate/app-translate.service';
import {FournisseurService} from 'src/app/modules/services/fournisseur/fournisseur.service';
import {ActivatedRoute} from '@angular/router';
import {isEmpty} from '../../../../utils/is-empty';
import {MontantPipe} from '../../../../modules/pipes/pipes/montant.pipe';

@Component({
    selector: 'app-recap-inscription-fournisseur',
    templateUrl: './recap-inscription-fournisseur.component.html',
    styleUrls: ['./recap-inscription-fournisseur.component.css'],
    providers: [MontantPipe],
})
export class RecapInscriptionFournisseurComponent implements OnInit {
    data: any[] = [];
    data2: any[] = [];
    datausine: any[] = [];
    dataProduit: any[] = [];
    dataAgrement: any[] = [];
    dataMandataire: any[] = [];

    langue: any;
    id: any;
    list = [];

    constructor(
        private transfer: TransferidFournisseurService,
        private translate: TranslateService,
        private activte: ActivatedRoute,
        private appTranslateService: AppTranslateService,
        private fournisseurservce: FournisseurService,
        private montant: MontantPipe
    ) {
    }

    ngOnInit(): void {
        this.activte.params.subscribe((params) => {

            this.id = params.id;
        });
        this.getdetail();
        this.langue = this.getlang();
    }

    getdetail() {
        this.fournisseurservce.getDetailFournisseurRecap(this.id).subscribe({
            next: (data) => {
                this.data = [data['umSupplier']];
                if (!isEmpty(this.data[0].capitalAmt)) {
                    this.data[0].capitalAmt = this.montant.transform(
                        this.data[0].capitalAmt
                    );
                }
                this.list = data['lst'];
                this.data2 = [data['umChief']];
                this.datausine = data['listUmFactory'];
                this.dataProduit = data['listUmSupplierItem'];
                this.dataAgrement = data['listUmLicense'];
                this.dataProduit = data['listUmSupplierItem'];
                this.dataMandataire = data['listUmAttorney'];

                //console.log('hamzaaaaaa',this.data2)
            },
        });
    }

    getlang() {
        this.appTranslateService.getDefaultLang();
    }
}
